import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

// Inject GetTerms CMP scripts at the very top of the <head>
const injectCmp = () => {
  if (document.getElementById('getterms-cmp-preload')) return;
  const preload = document.createElement('link');
  preload.id = 'getterms-cmp-preload';
  preload.rel = 'preload';
  preload.href = 'https://gettermscmp.com/cookie-consent/blocker/c2ebea30-4b5c-496c-8778-ae76249b52ad/cust?auto=true';
  preload.as = 'script';
  const script1 = document.createElement('script');
  script1.type = 'text/javascript';
  script1.src = 'https://gettermscmp.com/cookie-consent/blocker/c2ebea30-4b5c-496c-8778-ae76249b52ad/cust?auto=true';
  const script2 = document.createElement('script');
  script2.type = 'text/javascript';
  script2.async = true;
  script2.src = 'https://gettermscmp.com/cookie-consent/widget/c2ebea30-4b5c-496c-8778-ae76249b52ad/cust?auto=true';

  // Prepend in reverse order so they end up in the correct order at the top
  document.head.prepend(script2);
  document.head.prepend(script1);
  document.head.prepend(preload);
};
injectCmp();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<BrowserRouter data-id="element-313" data-mp="voz7pzh3ydyg">
      <App data-id="element-314" data-mp="vpr1d4r5a1m3" />
    </BrowserRouter>);
}